module.exports = __webpack_public_path__ + "img/tb@2x.75c8980c.png";